import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import stockMasterServices from '@Services/inventory/stockMasterServices';
import StockMasterActions, { stockMasterActionTypes } from '@Actions/inventory/stockMasterActions';

/**
 * @param action
 */
function* _getBatches(action) {
  try {
    yield put(StockMasterActions.getBatchesLoading(true));

    const batches = yield stockMasterServices.getBatches(action.payload);
    yield put(StockMasterActions.getBatchesSuccess(batches));
    if (action.callback) {
      action.callback(batches);
    }
    yield put(StockMasterActions.getBatchesLoading(false));
  } catch (error) {
    yield put(StockMasterActions.getBatchesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(stockMasterActionTypes.GET_BATCHES_DATA.ERROR, error));
  }
}

/**
 *
 */
function* getBatches() {
  yield takeLatest(stockMasterActionTypes.GET_BATCHES_DATA.REQUEST, _getBatches);
}

/**
 *
 * @param {*} action
 */
function* _updateBatch(action) {
  try {
    yield put(StockMasterActions.updateBatchesLoading(true));
    const updatebatch = yield stockMasterServices.updateBatches(action.payload);
    if (updatebatch.success) {
      yield put(TrackerActions.trackAction(stockMasterActionTypes.UPDATE_BATCH_DATA.SUCCESS, updatebatch.data));
      notification.open({
        type: 'success',
        message: 'Batch information updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.updateBatchesLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: updatebatch.message,
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.updateBatchesLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(stockMasterActionTypes.UPDATE_BATCH_DATA.ERROR, error));
    yield put(StockMasterActions.updateBatchesLoading(false));
  }
}

/**
 *
 */
function* updateBatch() {
  yield takeLatest(stockMasterActionTypes.UPDATE_BATCH_DATA.REQUEST, _updateBatch);
}

/**
 *
 * @param {*} action
 */
function* _adjustBatch(action) {
  try {
    yield put(StockMasterActions.adjustBatchesLoading(true));
    const adjustbatch = yield stockMasterServices.adjustBatches(action.payload);
    if (adjustbatch.success) {
      yield put(TrackerActions.trackAction(stockMasterActionTypes.ADJUST_BATCH.SUCCESS, adjustbatch.data));
      notification.open({
        type: 'success',
        message: 'Adjustment Successfull',
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.adjustBatchesLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: adjustbatch.message,
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.adjustBatchesLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(stockMasterActionTypes.ADJUST_BATCH.ERROR, error));
    yield put(StockMasterActions.adjustBatchesLoading(false));
  }
}

/**
 *
 */
function* adjustBatch() {
  yield takeLatest(stockMasterActionTypes.ADJUST_BATCH.REQUEST, _adjustBatch);
}

function* _deleteBatch(action) {
  try {
    yield put(StockMasterActions.deleteBatchesLoading(true));
    const deleteBatches = yield stockMasterServices.deleteBatches(action.payload);
    if (deleteBatches.success) {
      yield put(TrackerActions.trackAction(stockMasterActionTypes.DELETE_BATCH_DATA.SUCCESS, deleteBatches.data));
      notification.open({
        type: 'success',
        message: 'Batch Line Data deleted successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.deleteBatchesLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: deleteBatches.message,
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.deleteBatchesLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(stockMasterActionTypes.DELETE_BATCH_DATA.ERROR, error));
    yield put(StockMasterActions.deleteBatchesLoading(false));
  }
}

/**
 *
 */
function* deleteBatch() {
  yield takeLatest(stockMasterActionTypes.DELETE_BATCH_DATA.REQUEST, _deleteBatch);
}

function* _createProductList(action) {
  try {
    yield put(StockMasterActions.createProductListLoading(true));
    const createdList = yield stockMasterServices.createProductList(action.payload);
    if (createdList.success) {
      yield put(TrackerActions.trackAction(stockMasterActionTypes.CREATE_PRODUCT_LIST.SUCCESS, createdList.data));
      notification.open({
        type: 'success',
        message: 'Product list created successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.createProductListLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: createdList.message,
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.createProductListLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(stockMasterActionTypes.CREATE_PRODUCT_LIST.ERROR, error));
    yield put(StockMasterActions.createProductListLoading(false));
  }
}



function* createProductList() {
  yield takeLatest(stockMasterActionTypes.CREATE_PRODUCT_LIST.REQUEST, _createProductList);
}

function* _updateProductList(action) {
  try {
    yield put(StockMasterActions.updateProductListLoading(true));
    const createdList = yield stockMasterServices.updateProductList(action.payload);
    if (createdList.success) {
      yield put(TrackerActions.trackAction(stockMasterActionTypes.UPDATE_PRODUCT_LIST.SUCCESS, createdList.data));
      notification.open({
        type: 'success',
        message: 'Product list updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.updateProductListLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: createdList.message,
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.updateProductListLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(stockMasterActionTypes.UPDATE_PRODUCT_LIST.ERROR, error));
    yield put(StockMasterActions.createProductListLoading(false));
  }
}



function* updateProductList() {
  yield takeLatest(stockMasterActionTypes.UPDATE_PRODUCT_LIST.REQUEST, _updateProductList);
}

function* _getProductList(action) {
  try {
    yield put(StockMasterActions.getProductListLoading(true));
    const { tenantId, keyword, page, limit } = action.payload;
    const productList = yield stockMasterServices.getProductList(tenantId, null, keyword, page, limit);
    if (productList.success) {
      yield put(StockMasterActions.getProductListSuccess(productList?.data));
      if (action.callback) {
        action.callback();
      }
    }
    yield put(StockMasterActions.getProductListLoading(false));
  } catch (error) {
    yield put(StockMasterActions.getProductListLoading(false));
  }
}

function* getProductList() {
  yield takeLatest(stockMasterActionTypes.GET_PRODUCT_LIST.REQUEST, _getProductList);
}

function* _getProductListById(action) {
  try {
    yield put(StockMasterActions.getProductListByIdLoading(true));
    const { tenantId, skuListId } = action.payload;
    const productList = yield stockMasterServices.getProductList(tenantId, skuListId);
    if (productList.success) {
      yield put(StockMasterActions.getProductListByIdSuccess(productList?.data?.[0]));
      if (action.callback) {
        action.callback(productList?.data?.[0]);
      }
    }
    yield put(StockMasterActions.getProductListByIdLoading(false));
  } catch (error) {
    yield put(StockMasterActions.getProductListByIdLoading(false));
  }
}

function* getProductListById() {
  yield takeLatest(stockMasterActionTypes.GET_PRODUCT_LIST_BY_ID.REQUEST, _getProductListById);
}

function* _addProductToList(action) {
  try {
    yield put(StockMasterActions.addProductToListLoading(true));
    const createdList = yield stockMasterServices.addProductToList(action.payload);
    if (createdList.success) {
      yield put(StockMasterActions.addProductToListLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: createdList.message,
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.addProductToListLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(StockMasterActions.addProductToListLoading(false));
  }
}

function* addProductToList() {
  yield takeLatest(stockMasterActionTypes.ADD_PRODUCT_TO_LIST.REQUEST, _addProductToList);
}

function* _removeProductFromList(action) {
  try {
    yield put(StockMasterActions.removeProductFromListLoading(true));
    const createdList = yield stockMasterServices.removeProductFromList(action.payload);
    if (createdList.success) {
      yield put(StockMasterActions.removeProductFromListLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: createdList.message,
        duration: 4,
        placement: 'top',
      });
      yield put(StockMasterActions.removeProductFromListLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(StockMasterActions.removeProductFromListLoading(false));
  }
}

function* removeProductFromList() {
  yield takeLatest(stockMasterActionTypes.REMOVE_PRODUCT_FROM_LIST.REQUEST, _removeProductFromList);
}

export default function* StockMasterSaga() {
  yield all([
    getBatches(),
    updateBatch(),
    deleteBatch(),
    adjustBatch(),
    createProductList(),
    getProductList(),
    getProductListById(),
    addProductToList(),
    removeProductFromList(),
    updateProductList(),
  ]);
}
